import { Component, OnInit, Input, OnChanges, SimpleChanges, AfterViewInit, Output, EventEmitter, ViewChild, ElementRef, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup, UntypedFormArray, UntypedFormBuilder, Validators, FormControl, AbstractControl, FormArray, FormGroup } from '@angular/forms';
import { DhlFormControlTable } from '../../models/dhl-form-control-table';
import {TranslateService} from '@ngx-translate/core';
import  {Constant}  from '../../../constants/constants';
import { Observable } from 'rxjs';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { map, shareReplay } from 'rxjs/operators';
import { ChangeDetectorRef } from '@angular/core'
import { FormService } from '../../services/form.service';
import { AlphaService } from 'src/app/app-business-object-module/alpha.service';
import { AppService } from 'src/app/app.service';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { APP_Constants } from 'src/app/app.constant';
import { CustomSnackBarService } from 'src/app/common/snack-bar/snack-bar.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Modal } from 'src/app/common/modal/modal';
import { Router } from '@angular/router';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';

const VIRTUAL_SCROLL_MINIMUM_LENGTH = 3;

@Component({
    selector: 'app-form-field-table',
    templateUrl: './form-field-table-v2.component.html',
    styleUrls: ['./form-field-table-v2.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormFieldTableV2Component implements OnInit, OnChanges, AfterViewInit {
  @Input() configData: DhlFormControlTable;
  @Input() frmGroup: UntypedFormGroup;
  @Output() loadingStatus = new EventEmitter();
  @ViewChild(CdkVirtualScrollViewport) private virtualScroll: CdkVirtualScrollViewport;
  @ViewChild('virtualRow') virtualRow: ElementRef;

  enum=Constant;
  flagAdd: boolean;
  selfServiceConfig : boolean = false;
  editField: boolean;
  templateData: any;
  lableForConfig: string;
  orderFormSubmitted: any;
  orderForm: any;
  lastScrollTop = 0;
  tableRows: AbstractControl<any, any>;
  tableRowsControls = [];
  tableRowsClone: AbstractControl<any, any>;
  isScrollPagination: boolean;
  scrollCurrentPage = 1;
  scrollLimit = 0;
  isLastPage = false;
  templatedata: any;
  formError: string;
  isLoading: any;
  modalService: any;
  durationInSeconds: number;
  isMassiveSearch: boolean = false;
  ignoreIsMassiveSearch: boolean = false;
  itemSize = 235;
  orderDetails: any = this.appService.getOrderDetails();
  isFormGroupDisabled: boolean = false;

  constructor(private formService: FormService, private breakpointObserver: BreakpointObserver, private formBuilder: UntypedFormBuilder, public translate: TranslateService, private changeDetector: ChangeDetectorRef, private appService: AppService, private alphaService : AlphaService,private _snackBar: CustomSnackBarService,private router: Router) { }
  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.HandsetPortrait)
  .pipe(
    map(result => result.matches),
    shareReplay()
  );
  allowedLine: boolean = true;
  uomData;

  ngOnChanges(changes: SimpleChanges ) {
    if(changes['isDeleteButton']){
      this.frmGroup.get(this.configData.name)['controls']['deleteButton'] = false;
    }
  }

  ngOnInit() {
    console.log(this.frmGroup);
    console.log(this.configData);
    localStorage.removeItem('poLine');
    this.tableRows = this.frmGroup.controls[this.configData.name];
    this.tableRowsClone = this.frmGroup.controls[this.configData.name];
    this.ignoreIsMassiveSearch = this.configData?.ignoreIsMassiveSearch;
    this.isMassiveSearch = localStorage.getItem('massiveSearch') === 'true' || this.ignoreIsMassiveSearch;
    const isMinimumLength = this.tableRows['controls'].length > VIRTUAL_SCROLL_MINIMUM_LENGTH;

    const isScrollPagination = this.configData?.scrollPagination && this.isMassiveSearch && isMinimumLength;
    if (isScrollPagination) {
      this.isScrollPagination = isScrollPagination;
      this.scrollLimit = this.configData?.scrollLimit;
      this.handleScrollPagination();
      this.appService.resetScrollPagination$.subscribe(() => {
        this.resetScrollPagination();
      });
    } else {
      this.tableRowsControls = this.tableRows['controls'];
    }

    if (this.orderDetails?.status && !(['CREATED', 'SHIP_NOT_CONFIRMED'].includes(this.orderDetails?.status?.toUpperCase())) && this.appService.getCurrentUrl() !== '/orders/create') {
      this.isFormGroupDisabled = true;
    }
    if(this.configData.customFormFlag){
      this.selfServiceConfig = false;
    }
    else if(sessionStorage.getItem('isSelfServiceConfig'))
    {
      this.selfServiceConfig = true;
    }

    let page = localStorage.getItem('templateName');
    if (this.configData?.allowOneRecordOnly && this.configData?.allowOneRecordOnly === true) {
      this.frmGroup.get(this.configData.name)['controls']['canAddItem'] = false;
      this.frmGroup.get(this.configData.name)['controls']['deleteButton'] = false;
    } else {
    this.frmGroup.get(this.configData.name)['controls']['canAddItem'] = true;
    this.frmGroup.get(this.configData.name)['controls']['deleteButton'] = true;
    }

    this.configData.validation.forEach((data)=>{

      if(data === 'OneOrMoreLines' && this.frmGroup.get(this.configData.name)['controls'].length < 2){
        this.frmGroup.get(this.configData.name)['controls']['deleteButton'] = false;
      }
      if (data === 'hidden') {
        if (!(this.frmGroup.get(this.configData.name)['hidden'] === false)) {
          this.frmGroup.get(this.configData.name)['hidden'] = true;
          // this.frmGroup.get(this.configData.name).updateValueAndValidity();
        }
      }
      if(data === 'optional' && this.frmGroup.get(this.configData.name)['controls'].length < 2){
        this.frmGroup.get(this.configData.name)['controls']['deleteButton'] = false;
        this.frmGroup.get(this.configData.name)['controls']['canAddItem'] = false;
      }

      if(data === 'ReadOnly'){
        this.frmGroup.get(this.configData.name)['controls']['deleteButton'] = false;
        this.frmGroup.get(this.configData.name)['controls']['canAddItem'] = false;
      }

    }, this);

    if (this.configData['editAccess']) {
      this.configData['editAccess'].forEach(row => {
        let persona;
        if (row.roleAccess) {
          persona = row.roleAccess;
        } else {
          persona = row.persona;
        }
        if (row.action == 'hidden' && this.checkFieldAccess(persona) == false) {
          this.frmGroup.get(this.configData.name)['controls']['deleteButton'] = false;
          this.frmGroup.get(this.configData.name)['controls']['canAddItem'] = false;
        }
      });
      this.frmGroup.get(this.configData.name).updateValueAndValidity();
    }
    // if (this.configData['dynamicVisibility']) {
    //   if (this.configData['dynamicVisibility'].action == 'hidden') {
    //     this.frmGroup.get(this.configData.name)['hidden'] = !this.checkAccess(this.configData['dynamicVisibility'].featureName);
    //     this.toggleVisibility(true);
    //   } 
    // }
    if (this.configData?.indexControlName && this.tableRows instanceof FormArray) {
      this.autoFillLineItemIndexesForGSKRD(this.tableRows, this.configData);
    }
  }
  checkAccess(access) {
    let menuPages = localStorage.getItem('menuPages');
    return menuPages.includes(access);
  }

  // addfield(e,ctrl,id,crlIdx){{
  //   if (this.configData !== null) {
  //     this.flagAdd= true
  //   }
  //   this.configData.controls.forEach((elm, idx) => {
  //     if(id===idx){
  //        this.configData.controls.push(ctrl)
  //     }
  //   })
  // }}

  editFieldConfig(sCancel, label,grouplabel)
  {
   
    if (label === 'addField') {
      this.editField = true;
      this.lableForConfig = label + "-" + this.configData.label;
      this.appService.setOrderTemplate(this.configData.controls[0]);
      this.templateData = this.configData.controls[0]
    } 
    else if (label == 'updateField') {
      if (this.configData !== null) {
        this.editField = true;
        this.appService.setOrderTemplate(grouplabel);
        this.templateData = grouplabel
      }
    }


    if (sCancel == 'cancel') {
      this.editField = false;
    }
  }

  
  getFormStatus(e) {
    this.orderFormSubmitted = e;
  }
  getForm(e) {
    this.orderForm = e;
  }

  
  removeFields(e,ctrl,id,crlIdx){
    if(sessionStorage.getItem("parentTemplate"))
      {
      let parentTemplate = JSON.parse(sessionStorage.getItem("parentTemplate"));
      if (parentTemplate.hasOwnProperty('sections')) {

      parentTemplate.sections.forEach(group => {
        group.groups.forEach((control) => {
          if (control?.controls && control?.controls[0].formType === 'FORM_ARRAY') {
            control?.controls[0].controls.forEach((elm, idx) => {
              if (id === idx) {
                if (crlIdx !== -1) {
                  control?.controls[0].controls.splice(crlIdx, 1);
                }
              }
            })
          }
        })
      })
    }else if(parentTemplate.hasOwnProperty('groups')){
      parentTemplate.groups.forEach(group => {
        group.controls.forEach(control => {
          if (control?.controls && control?.formType === 'FORM_ARRAY') {
            control?.controls.forEach((elm, idx) => {
              if (id === idx) {
                if (crlIdx !== -1) {
                  control?.controls.splice(crlIdx, 1);
                }
              }
            })
          }
        })
      })
    }
      localStorage.setItem("parentTemplate",JSON.stringify(parentTemplate));
      console.log("UPDATED_TEMPLATE",parentTemplate);
      this.templatedata = JSON.parse(localStorage.getItem('templatedata'));
      let url
      console.log("res---------------",this.templatedata);
      if(localStorage.getItem('filterCurrenturl')=='/selfServiceListing/selfconfigdraft')
      {
        url = APP_Constants.UI_SELF_CONFIG_SAVE +localStorage.getItem('userName')
        +'&customerCode='+this.templatedata.customer_id
        +'&configId='+this.templatedata.template_id
        +'&action='+this.templatedata.action
      }
         else {
          url = APP_Constants.UI_SELF_CONFIG_SAVE +localStorage.getItem('userName')
        +'&customerCode='+this.templatedata.customer_id
        +'&configId='+this.templatedata.template_id
        +'&action='+this.templatedata.action
        +'&listingType='+"UIListing"
    }
  
      console.log("url--------",url,parentTemplate)
      this.appService.makeHttpPostRequest(url,parentTemplate).subscribe((data) => {
        if (data['message'].statusCode == APP_Constants.SUCCESS_CODE) {
          this.formError = ''
          this.isLoading = false;
          this.loadingStatus.emit(this.isLoading);
         // this.normalView();
          let preferenceId = data['data'].preferenceId;
          let saveDraftMsg = `Draft created`;
          let tempdata =  JSON.parse(localStorage.getItem('templatedata'))
          this.router.navigateByUrl('/selfServiceListing/'+tempdata.customer_id+ "-"+tempdata.action);
          window.location.reload()

          console.log("data----------",data)
         this._snackBar.open({ orderId: preferenceId, message: data['message'].statusMessage }, { duration: this.durationInSeconds * 1000 });
        }
      }, err => {
        this.isLoading = false;
        this.loadingStatus.emit(this.isLoading);
       // this.normalView();

        let modal = new Modal({
          action: false, name: 'Updated', title: 'Update Json ', description: err.message, actionButtonText: ''
        });
        this.modalService.createModalBox(modal, err.status);
      });
      }
  //   this.configData.controls.forEach((elm, idx) => {
  //     if(id===idx){
  //     if (crlIdx !== -1) {
  //       this.configData.controls.splice(crlIdx, 1);
  //   } 
  // }   
  // })
  }

  addPoLine(){
    let fieldGroup = (<UntypedFormArray>this?.frmGroup?.controls[this?.configData?.name]);
    this.configData?.controls?.forEach((control) => {
      control?.validation?.forEach((element) => {
        let check = element?.split('-');
        if (check[1] === 'notMoreThanValue') {
          this.alphaService?.notMoreThanValue(check, this.frmGroup, control, fieldGroup);
        }
      })
    })
    var PoSelected = localStorage.getItem('TotalPoLinesSelected');
    var totalPoSelected = parseInt(PoSelected) + 1;
    localStorage.setItem('TotalPoLinesSelected',totalPoSelected.toString())
    if(document.getElementById('poSelectCount')){
    if(document.getElementById('poSelectCount')?.innerHTML) document.getElementById('poSelectCount').innerHTML = totalPoSelected.toString();
   }
 }

  ngAfterViewInit(){
    //CP-5794-start- field is disable 
    if(this.configData['disabled'] === true){
      this.frmGroup.get(this.configData.name).disable();
    }
    this.uomData =localStorage.getItem('preferredUOM');
    this.calculateItemSize();
  }

  // ngAfterViewChecked(){
  //   this.changeDetector.detectChanges();
  // }

  getControl(ctrl){
    return Object.assign({}, ctrl);
  }

  getFormTableControls(){
    return this.tableRowsControls;
  }

  getColsClass(cols: number[], control) {
    if(control.type == 'hidden'){
      return ''
    }
    const mediaBreakpoints = ['xl', 'lg', 'md', 'sm', 'xs', 'col'];
    let colsClass = '';
    for ( let i = 0; i < cols.length; i++) {
      colsClass += 'col-' + mediaBreakpoints[i] + '-' + cols[i] + ' ';
    }

    if(control.hasOwnProperty("makeDwarf") && control.makeDwarf){
      colsClass += 'dwarf' + ' ';
    }

    return colsClass;
  }

  drop(event: CdkDragDrop<string[]>,label) {
    moveItemInArray(this.configData.controls, event.previousIndex, event.currentIndex);
  }

  toggleVisibility(hidden = !this.frmGroup.get(this.configData.name)['hidden']){
    this.configData.required = hidden ? !hidden : this.configData.required;
    this.frmGroup.get(this.configData.name)['hidden'] = hidden;
    if (hidden === true) {
      this.frmGroup.get(this.configData.name).reset();
      this.frmGroup.get(this.configData.name).updateValueAndValidity();
      //Cp-3619 - start -User is not able to save the order when the 'Fees and Payment' toggle is off while updating
      if (this.configData['controls'] && this.frmGroup.get(this.configData.name)['controls']) {
        this.resetControls(this.configData, this.frmGroup.get(this.configData.name));
      }  //cp-3619 - end
    }
    this.changeDetector.detectChanges();
  }

  //Cp-3619 - start -User is not able to save the order when the 'Fees and Payment' toggle is off while updating
  resetControls(data, frmGrp) {
    if (frmGrp['controls']) {
      frmGrp['controls'].forEach((ctrl) => {
        for (let j = 0; j < data['controls'].length; j++) {
          let element = data.controls[j];
          ctrl.get(element.name).reset();
          ctrl.get(element.name).updateValueAndValidity();
          ctrl.get(element.name).setErrors(null);
          if(element.defaultValue.dataType === "BOOLEAN"){
            ctrl.get(element.name).setValue(Boolean(JSON.parse(element.defaultValue?.value)))
          }
          
          if (element.validation.includes('hidden')) {
            ctrl.get(element.name)['hidden'] = true;
          }

          if (element.controls) {
            this.resetControls(element, ctrl.get(element.name))
          }
        }
      })
    }
  }//Cp-3619 - end

  addItem(e) {
    e.preventDefault();
    let grp ={};

    this.configData.controls.forEach((field)=>{
      grp[field.name] = this.formService.createFormControl(field);
//       grp[field.name] = field.required === true ? new FormControl
//                 (field.defaultValue || field.defaultValue == false ? field.defaultValue: '',
//                     [Validators.required, Validators.maxLength(parseInt(field['maxLength']))]) :
//                         new FormControl(field.defaultValue || field.defaultValue == false ? field.defaultValue: '',
//                             Validators.maxLength(parseInt(field['maxLength'])));
    });
    (<UntypedFormArray>this.tableRows).push(new UntypedFormGroup(grp));

    if (this.configData?.indexControlName && this.tableRows instanceof FormArray) {
      this.autoFillLineItemIndexesForGSKRD(this.tableRows, this.configData);
    }
    
    this.allowedLine = true;
    this.frmGroup.get(this.configData.name)['controls']['deleteButton'] = true;
    this.sendToSource(e, 'ADD_REMOVE_ROW');

    if (this.isScrollPagination) { this.handleScrollPagination(); }
    this.appService.groupValidationSubscription();
  }

  copyItem(e, rowIndex) {
    e.preventDefault();
    let grp = {};

    this.configData?.controls?.forEach((field) => {
      grp[field.name] = this.formService.createFormControl(field);
    });

    const newFormGroup = new UntypedFormGroup(grp);
    const tableRows = <UntypedFormArray>this.tableRows;
    if (tableRows?.length > 0) {
      const copiedFromGroupSelection = tableRows?.at(rowIndex);
      if (copiedFromGroupSelection) {
        newFormGroup.patchValue(copiedFromGroupSelection?.value);
      }
    }

    if (this.configData?.excludeItemsFromCopy) {
      for (const item of this.configData?.excludeItemsFromCopy) {
        let excludeItemsFromCopy = newFormGroup.get('accordianComponent.0.' + item) as FormArray;
        excludeItemsFromCopy.reset();
      }
    }

    tableRows.push(newFormGroup);
    if (this.configData?.indexControlName && this.tableRows instanceof FormArray) {
      this.autoFillLineItemIndexesForGSKRD(this.tableRows, this.configData);
    }

    this.allowedLine = true;
    this.frmGroup.get(this.configData.name)['controls']['deleteButton'] = true;
    this.sendToSource(e, 'ADD_REMOVE_ROW');
    if (this.isScrollPagination) { this.handleScrollPagination(); }
    this.appService.groupValidationSubscription();
    this.appService.handleValidateWhenSelectedProp();
  }
  
  deleteItem( e, index: number) {    
    e.preventDefault();    
    this.sendToSource(e, 'ADD_REMOVE_ROW');
    let count = 0;
    (<UntypedFormArray>this.tableRows).removeAt(index);
    this.frmGroup.markAsTouched();
    this.configData.validation.forEach((elem)=>{
      if(elem === "OneOrMoreLines"){
        if((<UntypedFormArray>this.tableRows).length === 1){
          this.frmGroup.get(this.configData.name)['controls']['deleteButton'] = false;
        }
      }
      (<UntypedFormArray>this.tableRows)
    }, this);
    this.tableRows.value.forEach((line, idx)=>{
      if(line.poLineItemId1){
        count++;
      }
    })
    // if(count == 0){
    //   localStorage.removeItem('poSourceId');
    //   localStorage.removeItem('poDestId');
    //   if(this.frmGroup.controls[this.configData.name].parent.controls['source']){
    //     this.frmGroup.controls[this.configData.name].parent.controls['source'].setValue("");
    //   }
    //   if(this.frmGroup.controls[this.configData.name].parent.controls['destination']){
    //     this.frmGroup.controls[this.configData.name].parent.controls['destination'].setValue("");
    //   }
    // }

    var PoSelected = localStorage.getItem('TotalPoLinesSelected');
    var totalPoSelected = parseInt(PoSelected) - 1;
    localStorage.setItem('TotalPoLinesSelected',totalPoSelected.toString())
    if(document.getElementById('poSelectCount')) {
    if(document.getElementById('poSelectCount')?.innerHTML) document.getElementById('poSelectCount').innerHTML = totalPoSelected.toString();
    }
    let fieldGroup = (<UntypedFormArray>this?.frmGroup?.controls[this?.configData?.name]);
    this.configData?.controls?.forEach((control) => {
      control?.validation?.forEach((element) => {
        let check = element?.split('-');
        if (check[1] === 'notMoreThanValue') {
          this.alphaService?.notMoreThanValue(check, this.frmGroup, control, fieldGroup);
        }
      })
    })

    if (this.isScrollPagination) { this.handleScrollPagination(); }
  }
  sendToSource(event, action) {
    let eventData = {
      event: event,
      action: action,
      name: this.configData.name,
      component: this,
      configData: this.configData,
      data: this.frmGroup.get(this.configData.name).value
    }
    this.appService._commonComponentSubject.next(eventData);
  }

  checkFieldAccess(persona) {
    let role = localStorage.getItem('userRole');
    return persona.includes(role);
  }

  onScroll() {
    const top = Math.floor(this.virtualScroll.measureScrollOffset("top"));
    const bottom = Math.floor(this.virtualScroll.measureScrollOffset("bottom"));

    const isScrollDown = top > this.lastScrollTop;

    if (isScrollDown && bottom <= 10) {
      this.handleScrollPagination(true);
    }

    this.lastScrollTop = top;
  }

  handleScrollPagination(isNewPage = false) {
    const rows = this.tableRows as UntypedFormArray;
    const rowsControls = rows.controls;
    const totalPages = Math.ceil(rowsControls.length / this.scrollLimit);

    if (isNewPage && !this.isLastPage) this.scrollCurrentPage++;
    if (this.scrollCurrentPage === totalPages) this.isLastPage = true;

    const nextPageCalc = this.isLastPage ? rowsControls.length : this.scrollCurrentPage * this.scrollLimit;
    const nextPageItems = rowsControls.filter((row, index) => index + 1 <= nextPageCalc);
    this.tableRowsControls = nextPageItems;
  }

  resetScrollPagination(resetStage = false) {
    setTimeout(() => {
      if (resetStage) {
        this.scrollCurrentPage = 1;
        this.isLastPage = false;
      }
      this.handleScrollPagination(false);
    }, 50);
  }

  calculateItemSize() {
    setTimeout(() => {
      if (this.virtualScroll && this.virtualRow) {
        const itemElement = this.virtualRow.nativeElement;
        this.itemSize = itemElement.offsetHeight;
        this.virtualScroll.checkViewportSize();
      }
    }, 500);
  }

  autoFillLineItemIndexesForGSKRD(tableRows, configData) {
    const tableArray = tableRows as FormArray;
    const fieldName = configData.indexControlName;

    const findField = (row: AbstractControl): FormControl | null => {
      return this.alphaService.findNestedControl(fieldName, row);
    };

    tableArray.controls.forEach((row, index) => {
      const field = findField(row);
      if (!field) return;

      const isEmpty = field.value === null || field.value === undefined || field.value === "";
      if (!isEmpty) return;

      let prevValue = index;
      const prevRow = tableArray.controls[index - 1];

      if (prevRow) {
        const prevField = findField(prevRow);
        if (prevField && !isNaN(prevField.value)) {
          prevValue = parseInt(prevField.value, 10);
        }
      }

      field.setValue(String(prevValue + 1), { emitEvent: false });
    });

    this.changeDetector.detectChanges();
  }

  onVirtualScrollItemLoaded() {
    if (this.isFormGroupDisabled) {
      this.frmGroup.disable();
    }
  }
}